/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ImpersonateRouteImport } from './routes/impersonate'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppProfileRouteImport } from './routes/_app/profile'
import { Route as AppMaintenanceServicesRouteImport } from './routes/_app/maintenance-services'
import { Route as AppMaintenanceCostsRouteImport } from './routes/_app/maintenance-costs'
import { Route as AppMaintenanceRouteImport } from './routes/_app/maintenance'
import { Route as AppHomeRouteImport } from './routes/_app/home'
import { Route as AppConsumptionRouteImport } from './routes/_app/consumption'
import { Route as AppVisitsIndexRouteImport } from './routes/_app/visits/index'
import { Route as AppMessagesIndexRouteImport } from './routes/_app/messages/index'
import { Route as AppMaintenanceLogIndexRouteImport } from './routes/_app/maintenance-log/index'
import { Route as AppCompanyPortalIndexRouteImport } from './routes/_app/company-portal/index'
import { Route as AuthGoogleCallbackRouteImport } from './routes/auth.google.callback'
import { Route as AppVisitsIdRouteImport } from './routes/_app/visits/$id'
import { Route as AppMessagesIdRouteImport } from './routes/_app/messages/$id'
import { Route as AppMaintenanceLogIdRouteImport } from './routes/_app/maintenance-log/$id'
import { Route as AppPropertiesPropertyIdIndexRouteImport } from './routes/_app/properties/$propertyId/index'
import { Route as AppCompanyPortalCompanyIdIndexRouteImport } from './routes/_app/company-portal/$companyId/index'
import { Route as AppCompanyPortalCompanyIdSettingsRouteImport } from './routes/_app/company-portal/$companyId/settings'
import { Route as AppCompanyPortalCompanyIdVisitsIndexRouteImport } from './routes/_app/company-portal/$companyId/visits/index'
import { Route as AppCompanyPortalCompanyIdVisitsVisitIdRouteImport } from './routes/_app/company-portal/$companyId/visits/$visitId'
import { Route as AppCompanyPortalCompanyIdPropertiesPropertyIdIndexRouteImport } from './routes/_app/company-portal/$companyId/properties/$propertyId/index'

const ImpersonateRoute = ImpersonateRouteImport.update({
  id: '/impersonate',
  path: '/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppMaintenanceServicesRoute = AppMaintenanceServicesRouteImport.update({
  id: '/maintenance-services',
  path: '/maintenance-services',
  getParentRoute: () => AppRoute,
} as any)
const AppMaintenanceCostsRoute = AppMaintenanceCostsRouteImport.update({
  id: '/maintenance-costs',
  path: '/maintenance-costs',
  getParentRoute: () => AppRoute,
} as any)
const AppMaintenanceRoute = AppMaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)
const AppConsumptionRoute = AppConsumptionRouteImport.update({
  id: '/consumption',
  path: '/consumption',
  getParentRoute: () => AppRoute,
} as any)
const AppVisitsIndexRoute = AppVisitsIndexRouteImport.update({
  id: '/visits/',
  path: '/visits/',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesIndexRoute = AppMessagesIndexRouteImport.update({
  id: '/messages/',
  path: '/messages/',
  getParentRoute: () => AppRoute,
} as any)
const AppMaintenanceLogIndexRoute = AppMaintenanceLogIndexRouteImport.update({
  id: '/maintenance-log/',
  path: '/maintenance-log/',
  getParentRoute: () => AppRoute,
} as any)
const AppCompanyPortalIndexRoute = AppCompanyPortalIndexRouteImport.update({
  id: '/company-portal/',
  path: '/company-portal/',
  getParentRoute: () => AppRoute,
} as any)
const AuthGoogleCallbackRoute = AuthGoogleCallbackRouteImport.update({
  id: '/auth/google/callback',
  path: '/auth/google/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppVisitsIdRoute = AppVisitsIdRouteImport.update({
  id: '/visits/$id',
  path: '/visits/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesIdRoute = AppMessagesIdRouteImport.update({
  id: '/messages/$id',
  path: '/messages/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppMaintenanceLogIdRoute = AppMaintenanceLogIdRouteImport.update({
  id: '/maintenance-log/$id',
  path: '/maintenance-log/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppPropertiesPropertyIdIndexRoute =
  AppPropertiesPropertyIdIndexRouteImport.update({
    id: '/properties/$propertyId/',
    path: '/properties/$propertyId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCompanyPortalCompanyIdIndexRoute =
  AppCompanyPortalCompanyIdIndexRouteImport.update({
    id: '/company-portal/$companyId/',
    path: '/company-portal/$companyId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCompanyPortalCompanyIdSettingsRoute =
  AppCompanyPortalCompanyIdSettingsRouteImport.update({
    id: '/company-portal/$companyId/settings',
    path: '/company-portal/$companyId/settings',
    getParentRoute: () => AppRoute,
  } as any)
const AppCompanyPortalCompanyIdVisitsIndexRoute =
  AppCompanyPortalCompanyIdVisitsIndexRouteImport.update({
    id: '/company-portal/$companyId/visits/',
    path: '/company-portal/$companyId/visits/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCompanyPortalCompanyIdVisitsVisitIdRoute =
  AppCompanyPortalCompanyIdVisitsVisitIdRouteImport.update({
    id: '/company-portal/$companyId/visits/$visitId',
    path: '/company-portal/$companyId/visits/$visitId',
    getParentRoute: () => AppRoute,
  } as any)
const AppCompanyPortalCompanyIdPropertiesPropertyIdIndexRoute =
  AppCompanyPortalCompanyIdPropertiesPropertyIdIndexRouteImport.update({
    id: '/company-portal/$companyId/properties/$propertyId/',
    path: '/company-portal/$companyId/properties/$propertyId/',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/impersonate': typeof ImpersonateRoute
  '/consumption': typeof AppConsumptionRoute
  '/home': typeof AppHomeRoute
  '/maintenance': typeof AppMaintenanceRoute
  '/maintenance-costs': typeof AppMaintenanceCostsRoute
  '/maintenance-services': typeof AppMaintenanceServicesRoute
  '/profile': typeof AppProfileRoute
  '/maintenance-log/$id': typeof AppMaintenanceLogIdRoute
  '/messages/$id': typeof AppMessagesIdRoute
  '/visits/$id': typeof AppVisitsIdRoute
  '/auth/google/callback': typeof AuthGoogleCallbackRoute
  '/company-portal': typeof AppCompanyPortalIndexRoute
  '/maintenance-log': typeof AppMaintenanceLogIndexRoute
  '/messages': typeof AppMessagesIndexRoute
  '/visits': typeof AppVisitsIndexRoute
  '/company-portal/$companyId/settings': typeof AppCompanyPortalCompanyIdSettingsRoute
  '/company-portal/$companyId': typeof AppCompanyPortalCompanyIdIndexRoute
  '/properties/$propertyId': typeof AppPropertiesPropertyIdIndexRoute
  '/company-portal/$companyId/visits/$visitId': typeof AppCompanyPortalCompanyIdVisitsVisitIdRoute
  '/company-portal/$companyId/visits': typeof AppCompanyPortalCompanyIdVisitsIndexRoute
  '/company-portal/$companyId/properties/$propertyId': typeof AppCompanyPortalCompanyIdPropertiesPropertyIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/impersonate': typeof ImpersonateRoute
  '/consumption': typeof AppConsumptionRoute
  '/home': typeof AppHomeRoute
  '/maintenance': typeof AppMaintenanceRoute
  '/maintenance-costs': typeof AppMaintenanceCostsRoute
  '/maintenance-services': typeof AppMaintenanceServicesRoute
  '/profile': typeof AppProfileRoute
  '/maintenance-log/$id': typeof AppMaintenanceLogIdRoute
  '/messages/$id': typeof AppMessagesIdRoute
  '/visits/$id': typeof AppVisitsIdRoute
  '/auth/google/callback': typeof AuthGoogleCallbackRoute
  '/company-portal': typeof AppCompanyPortalIndexRoute
  '/maintenance-log': typeof AppMaintenanceLogIndexRoute
  '/messages': typeof AppMessagesIndexRoute
  '/visits': typeof AppVisitsIndexRoute
  '/company-portal/$companyId/settings': typeof AppCompanyPortalCompanyIdSettingsRoute
  '/company-portal/$companyId': typeof AppCompanyPortalCompanyIdIndexRoute
  '/properties/$propertyId': typeof AppPropertiesPropertyIdIndexRoute
  '/company-portal/$companyId/visits/$visitId': typeof AppCompanyPortalCompanyIdVisitsVisitIdRoute
  '/company-portal/$companyId/visits': typeof AppCompanyPortalCompanyIdVisitsIndexRoute
  '/company-portal/$companyId/properties/$propertyId': typeof AppCompanyPortalCompanyIdPropertiesPropertyIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/impersonate': typeof ImpersonateRoute
  '/_app/consumption': typeof AppConsumptionRoute
  '/_app/home': typeof AppHomeRoute
  '/_app/maintenance': typeof AppMaintenanceRoute
  '/_app/maintenance-costs': typeof AppMaintenanceCostsRoute
  '/_app/maintenance-services': typeof AppMaintenanceServicesRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/maintenance-log/$id': typeof AppMaintenanceLogIdRoute
  '/_app/messages/$id': typeof AppMessagesIdRoute
  '/_app/visits/$id': typeof AppVisitsIdRoute
  '/auth/google/callback': typeof AuthGoogleCallbackRoute
  '/_app/company-portal/': typeof AppCompanyPortalIndexRoute
  '/_app/maintenance-log/': typeof AppMaintenanceLogIndexRoute
  '/_app/messages/': typeof AppMessagesIndexRoute
  '/_app/visits/': typeof AppVisitsIndexRoute
  '/_app/company-portal/$companyId/settings': typeof AppCompanyPortalCompanyIdSettingsRoute
  '/_app/company-portal/$companyId/': typeof AppCompanyPortalCompanyIdIndexRoute
  '/_app/properties/$propertyId/': typeof AppPropertiesPropertyIdIndexRoute
  '/_app/company-portal/$companyId/visits/$visitId': typeof AppCompanyPortalCompanyIdVisitsVisitIdRoute
  '/_app/company-portal/$companyId/visits/': typeof AppCompanyPortalCompanyIdVisitsIndexRoute
  '/_app/company-portal/$companyId/properties/$propertyId/': typeof AppCompanyPortalCompanyIdPropertiesPropertyIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/impersonate'
    | '/consumption'
    | '/home'
    | '/maintenance'
    | '/maintenance-costs'
    | '/maintenance-services'
    | '/profile'
    | '/maintenance-log/$id'
    | '/messages/$id'
    | '/visits/$id'
    | '/auth/google/callback'
    | '/company-portal'
    | '/maintenance-log'
    | '/messages'
    | '/visits'
    | '/company-portal/$companyId/settings'
    | '/company-portal/$companyId'
    | '/properties/$propertyId'
    | '/company-portal/$companyId/visits/$visitId'
    | '/company-portal/$companyId/visits'
    | '/company-portal/$companyId/properties/$propertyId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/impersonate'
    | '/consumption'
    | '/home'
    | '/maintenance'
    | '/maintenance-costs'
    | '/maintenance-services'
    | '/profile'
    | '/maintenance-log/$id'
    | '/messages/$id'
    | '/visits/$id'
    | '/auth/google/callback'
    | '/company-portal'
    | '/maintenance-log'
    | '/messages'
    | '/visits'
    | '/company-portal/$companyId/settings'
    | '/company-portal/$companyId'
    | '/properties/$propertyId'
    | '/company-portal/$companyId/visits/$visitId'
    | '/company-portal/$companyId/visits'
    | '/company-portal/$companyId/properties/$propertyId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/impersonate'
    | '/_app/consumption'
    | '/_app/home'
    | '/_app/maintenance'
    | '/_app/maintenance-costs'
    | '/_app/maintenance-services'
    | '/_app/profile'
    | '/_app/maintenance-log/$id'
    | '/_app/messages/$id'
    | '/_app/visits/$id'
    | '/auth/google/callback'
    | '/_app/company-portal/'
    | '/_app/maintenance-log/'
    | '/_app/messages/'
    | '/_app/visits/'
    | '/_app/company-portal/$companyId/settings'
    | '/_app/company-portal/$companyId/'
    | '/_app/properties/$propertyId/'
    | '/_app/company-portal/$companyId/visits/$visitId'
    | '/_app/company-portal/$companyId/visits/'
    | '/_app/company-portal/$companyId/properties/$propertyId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  ImpersonateRoute: typeof ImpersonateRoute
  AuthGoogleCallbackRoute: typeof AuthGoogleCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/impersonate': {
      id: '/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof ImpersonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/maintenance-services': {
      id: '/_app/maintenance-services'
      path: '/maintenance-services'
      fullPath: '/maintenance-services'
      preLoaderRoute: typeof AppMaintenanceServicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/maintenance-costs': {
      id: '/_app/maintenance-costs'
      path: '/maintenance-costs'
      fullPath: '/maintenance-costs'
      preLoaderRoute: typeof AppMaintenanceCostsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/maintenance': {
      id: '/_app/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof AppMaintenanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/consumption': {
      id: '/_app/consumption'
      path: '/consumption'
      fullPath: '/consumption'
      preLoaderRoute: typeof AppConsumptionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/visits/': {
      id: '/_app/visits/'
      path: '/visits'
      fullPath: '/visits'
      preLoaderRoute: typeof AppVisitsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages/': {
      id: '/_app/messages/'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AppMessagesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/maintenance-log/': {
      id: '/_app/maintenance-log/'
      path: '/maintenance-log'
      fullPath: '/maintenance-log'
      preLoaderRoute: typeof AppMaintenanceLogIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/company-portal/': {
      id: '/_app/company-portal/'
      path: '/company-portal'
      fullPath: '/company-portal'
      preLoaderRoute: typeof AppCompanyPortalIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/google/callback': {
      id: '/auth/google/callback'
      path: '/auth/google/callback'
      fullPath: '/auth/google/callback'
      preLoaderRoute: typeof AuthGoogleCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/visits/$id': {
      id: '/_app/visits/$id'
      path: '/visits/$id'
      fullPath: '/visits/$id'
      preLoaderRoute: typeof AppVisitsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages/$id': {
      id: '/_app/messages/$id'
      path: '/messages/$id'
      fullPath: '/messages/$id'
      preLoaderRoute: typeof AppMessagesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/maintenance-log/$id': {
      id: '/_app/maintenance-log/$id'
      path: '/maintenance-log/$id'
      fullPath: '/maintenance-log/$id'
      preLoaderRoute: typeof AppMaintenanceLogIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/properties/$propertyId/': {
      id: '/_app/properties/$propertyId/'
      path: '/properties/$propertyId'
      fullPath: '/properties/$propertyId'
      preLoaderRoute: typeof AppPropertiesPropertyIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/company-portal/$companyId/': {
      id: '/_app/company-portal/$companyId/'
      path: '/company-portal/$companyId'
      fullPath: '/company-portal/$companyId'
      preLoaderRoute: typeof AppCompanyPortalCompanyIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/company-portal/$companyId/settings': {
      id: '/_app/company-portal/$companyId/settings'
      path: '/company-portal/$companyId/settings'
      fullPath: '/company-portal/$companyId/settings'
      preLoaderRoute: typeof AppCompanyPortalCompanyIdSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/company-portal/$companyId/visits/': {
      id: '/_app/company-portal/$companyId/visits/'
      path: '/company-portal/$companyId/visits'
      fullPath: '/company-portal/$companyId/visits'
      preLoaderRoute: typeof AppCompanyPortalCompanyIdVisitsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/company-portal/$companyId/visits/$visitId': {
      id: '/_app/company-portal/$companyId/visits/$visitId'
      path: '/company-portal/$companyId/visits/$visitId'
      fullPath: '/company-portal/$companyId/visits/$visitId'
      preLoaderRoute: typeof AppCompanyPortalCompanyIdVisitsVisitIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/company-portal/$companyId/properties/$propertyId/': {
      id: '/_app/company-portal/$companyId/properties/$propertyId/'
      path: '/company-portal/$companyId/properties/$propertyId'
      fullPath: '/company-portal/$companyId/properties/$propertyId'
      preLoaderRoute: typeof AppCompanyPortalCompanyIdPropertiesPropertyIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppConsumptionRoute: typeof AppConsumptionRoute
  AppHomeRoute: typeof AppHomeRoute
  AppMaintenanceRoute: typeof AppMaintenanceRoute
  AppMaintenanceCostsRoute: typeof AppMaintenanceCostsRoute
  AppMaintenanceServicesRoute: typeof AppMaintenanceServicesRoute
  AppProfileRoute: typeof AppProfileRoute
  AppMaintenanceLogIdRoute: typeof AppMaintenanceLogIdRoute
  AppMessagesIdRoute: typeof AppMessagesIdRoute
  AppVisitsIdRoute: typeof AppVisitsIdRoute
  AppCompanyPortalIndexRoute: typeof AppCompanyPortalIndexRoute
  AppMaintenanceLogIndexRoute: typeof AppMaintenanceLogIndexRoute
  AppMessagesIndexRoute: typeof AppMessagesIndexRoute
  AppVisitsIndexRoute: typeof AppVisitsIndexRoute
  AppCompanyPortalCompanyIdSettingsRoute: typeof AppCompanyPortalCompanyIdSettingsRoute
  AppCompanyPortalCompanyIdIndexRoute: typeof AppCompanyPortalCompanyIdIndexRoute
  AppPropertiesPropertyIdIndexRoute: typeof AppPropertiesPropertyIdIndexRoute
  AppCompanyPortalCompanyIdVisitsVisitIdRoute: typeof AppCompanyPortalCompanyIdVisitsVisitIdRoute
  AppCompanyPortalCompanyIdVisitsIndexRoute: typeof AppCompanyPortalCompanyIdVisitsIndexRoute
  AppCompanyPortalCompanyIdPropertiesPropertyIdIndexRoute: typeof AppCompanyPortalCompanyIdPropertiesPropertyIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppConsumptionRoute: AppConsumptionRoute,
  AppHomeRoute: AppHomeRoute,
  AppMaintenanceRoute: AppMaintenanceRoute,
  AppMaintenanceCostsRoute: AppMaintenanceCostsRoute,
  AppMaintenanceServicesRoute: AppMaintenanceServicesRoute,
  AppProfileRoute: AppProfileRoute,
  AppMaintenanceLogIdRoute: AppMaintenanceLogIdRoute,
  AppMessagesIdRoute: AppMessagesIdRoute,
  AppVisitsIdRoute: AppVisitsIdRoute,
  AppCompanyPortalIndexRoute: AppCompanyPortalIndexRoute,
  AppMaintenanceLogIndexRoute: AppMaintenanceLogIndexRoute,
  AppMessagesIndexRoute: AppMessagesIndexRoute,
  AppVisitsIndexRoute: AppVisitsIndexRoute,
  AppCompanyPortalCompanyIdSettingsRoute:
    AppCompanyPortalCompanyIdSettingsRoute,
  AppCompanyPortalCompanyIdIndexRoute: AppCompanyPortalCompanyIdIndexRoute,
  AppPropertiesPropertyIdIndexRoute: AppPropertiesPropertyIdIndexRoute,
  AppCompanyPortalCompanyIdVisitsVisitIdRoute:
    AppCompanyPortalCompanyIdVisitsVisitIdRoute,
  AppCompanyPortalCompanyIdVisitsIndexRoute:
    AppCompanyPortalCompanyIdVisitsIndexRoute,
  AppCompanyPortalCompanyIdPropertiesPropertyIdIndexRoute:
    AppCompanyPortalCompanyIdPropertiesPropertyIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ImpersonateRoute: ImpersonateRoute,
  AuthGoogleCallbackRoute: AuthGoogleCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
